import { PURGE } from "redux-persist";
import { Organization } from "types";

const initialState = {
  practices: [],
  loading: false,
  error: null,
};

interface PracticeReducerType {
  practices: Organization[];
  loading: boolean;
  error: string | null;
}

const practicesReducer = (
  state: PracticeReducerType = initialState,
  action: any
) => {
  switch (action.type) {
    case "FETCH_PRACTICES":
      return {
        ...state,
        practices: action.payload,
        loading: false,
        error: null,
      };
    case "ADD_PRACTICE":
      return {
        ...state,
        practices: [...state.practices, action.payload],
      };
    case "UPDATE_PRACTICE":
      return {
        ...state,
        practices: state.practices.map((practice) =>
          practice.uuid === action.payload.uuid ? action.payload : practice
        ),
      };
    case "DELETE_PRACTICE":
      return {
        ...state,
        practices: state.practices.filter(
          (practice) => practice.uuid !== action.payload
        ),
      };
    case "SET_PRACTICES_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case "SET_PRACTICES_ERROR":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case PURGE:
      return initialState;
    default:
      return state;
  }
};

export default practicesReducer;
